import script from "./InstitutionalFormatSectionEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstitutionalFormatSectionEdit.vue?vue&type=script&setup=true&lang=ts"

import "./InstitutionalFormatSectionEdit.vue?vue&type=style&index=0&id=1e1b1a38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e1b1a38"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QIcon,QChip});
